var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history__cas-entry"},[_c('main',{attrs:{"id":"history__cas-container","data-mfe-id":_vm.appName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }